export default __webpack_public_path__ + "static/media/blue-location-icon.b788ab7e.svg";